import styled from 'styled-components';

export const OrderSummaryContainerStyled = styled.div``;

export const OrderSummaryHeadingStyled = styled.h3`
	margin: 0;
`;

export const OrderSummaryHeaderContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-bottom: 16px;
	width: 100%;
`;
